import { createSystem, defaultConfig } from "@chakra-ui/react"

// Define the theme configuration
const themeConfig = {
  theme: {
    tokens: {
      colors: {
        // Brand palette derived from two anchor colors:
        // Hot pink/fuchsia (#E24890) and warm orange (#CF6D2D)
        brand: {
          50:  { value: '#FFF1F6' },
          100: { value: '#FFE3EE' },
          200: { value: '#FFC7DD' },
          300: { value: '#FFABCB' },
          400: { value: '#F478A8' },
          500: { value: '#E24890' },
          600: { value: '#C93A7C' },
          700: { value: '#AA2E66' },
          800: { value: '#8B2452' },
          900: { value: '#6C1A3E' },
        },
        accent: {
          orange:      { value: '#CF6D2D' },
          orangeLight: { value: '#E89560' },
          orangeDark:  { value: '#A85822' },
        },
        // Semantic colors using the new palette
        semantic: {
          background: { value: { base: '#FFFFFF', _dark: '#1A1A1A' } },
          surface: { value: { base: '#F8F8F8', _dark: '#262626' } },
          muted: { value: { base: '#F0F0F0', _dark: '#333333' } },
          border: { value: { base: '#E2E2E2', _dark: '#404040' } },
          text: { value: { base: '#1A1A1A', _dark: '#F0F0F0' } },
          textMuted: { value: { base: '#4A4A4A', _dark: '#B0B0B0' } },
          cardPink: { value: { base: '#FFF1F6', _dark: '#2E1520' } },
          cardOrange: { value: { base: '#FEF0E6', _dark: '#2E2014' } },
          cardHighlight: { value: { base: '#FFE3EE', _dark: '#3A1A2A' } },
        }
      },
      // ... rest of tokens remain the same
      fonts: {
        heading: { value: '"Playfair Display", Georgia, "Times New Roman", serif' },
        body: { value: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
      },
        shadows: {
        // ... existing shadow definitions
        xs: { value: { base: '0 1px 2px rgba(0, 0, 0, 0.05)', _dark: '0 1px 2px rgba(0, 0, 0, 0.3)' } },
        sm: { value: { base: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)', _dark: '0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3)' } },
        md: { value: { base: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)', _dark: '0 4px 6px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3)' } },
        lg: { value: { base: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)', _dark: '0 10px 15px rgba(0, 0, 0, 0.5), 0 4px 6px rgba(0, 0, 0, 0.4)' } },
        xl: { value: { base: '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)', _dark: '0 20px 25px rgba(0, 0, 0, 0.5), 0 10px 10px rgba(0, 0, 0, 0.4)' } },
        '2xl': { value: { base: '0 25px 50px rgba(0, 0, 0, 0.25)', _dark: '0 25px 50px rgba(0, 0, 0, 0.7)' } },
        outline: { value: { base: '0 0 0 3px rgba(226, 72, 144, 0.6)', _dark: '0 0 0 3px rgba(226, 72, 144, 0.6)' } },
        inner: { value: { base: 'inset 0 2px 4px rgba(0, 0, 0, 0.06)', _dark: 'inset 0 2px 4px rgba(0, 0, 0, 0.3)' } },
      }
    },
    components: {
      Button: {
        defaultProps: {
          colorScheme: 'brand',
        },
        baseStyle: {
          boxShadow: 'sm', // Apply a subtle shadow by default
        },
      },
      Card: {
        baseStyle: {
          container: {
            bg: 'semantic.surface',
            borderColor: 'semantic.border',
            boxShadow: 'md', // Apply a standard shadow to cards
          },
        },
      },
      Box: {
        variants: {
          elevated: {
            bg: 'semantic.surface',
            boxShadow: 'md',
            borderRadius: 'md',
          },
          outlined: {
            bg: 'semantic.surface',
            borderWidth: '1px',
            borderColor: 'semantic.border',
            borderRadius: 'md',
          }
        }
      },
    },
    config: {
      initialColorMode: 'dark', // Setting dark as default to match your palette
      useSystemColorMode: false,
    }
  }
};

// Create and export the system
export const system = createSystem(defaultConfig, themeConfig);

// For backwards compatibility if needed
export default themeConfig.theme;